import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Layers, Building2, Home as HomeIcon, Ruler } from "lucide-react";
import { SERVICES } from "../mock";
import { CtaBanner } from "./Home";

const IconMap = { layers: Layers, building: Building2, home: HomeIcon, ruler: Ruler };

export default function Services() {
  return (
    <main>
      <section className="pt-[140px] pb-16 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-4 text-[11px] tracking-[0.2em] text-[#1A1D14]/60 mb-6">
            <span className="inline-block w-1.5 h-1.5 bg-[#B29774]" />
            <span>SERVICES</span>
            <span className="w-10 h-px bg-[#1A1D14]/30" />
            <span>MOHAN LTD</span>
          </div>
          <h1 className="font-display text-[56px] md:text-[96px] leading-[0.95] font-medium tracking-[-0.03em]">
            Construction &<br /><span className="text-[#1A1D14]/40">building development.</span>
          </h1>
          <p className="mt-8 max-w-xl text-[#1A1D14]/70 leading-relaxed">
            A structured approach to construction across four core service areas — each shaped by project requirements and delivered with the same standards of quality and communication.
          </p>
        </div>
      </section>

      <section className="pb-24 bg-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 space-y-px bg-[#1A1D14]/10">
          {SERVICES.map((s, i) => {
            const Icon = IconMap[s.icon];
            return (
              <div key={s.id} id={s.id} className="bg-[#F9F8F6] py-12 lg:py-16 grid lg:grid-cols-12 gap-8 items-start scroll-mt-24">
                <div className="lg:col-span-1 text-[#B29774] text-sm tracking-widest">{s.num}</div>
                <div className="lg:col-span-3">
                  <Icon size={44} strokeWidth={1.25} className="text-[#1A1D14]" />
                  <h2 className="mt-6 font-display text-[32px] md:text-[42px] leading-tight font-medium tracking-[-0.02em]">{s.title}</h2>
                </div>
                <div className="lg:col-span-6">
                  <p className="text-[#1A1D14]/75 leading-relaxed text-[15px]">{s.long}</p>
                  <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {["Site preparation", "Structural work", "Fit-out", "Project management"].map((f) => (
                      <li key={f} className="flex items-center gap-3 text-sm text-[#1A1D14]/80">
                        <span className="inline-block w-1.5 h-1.5 bg-[#B29774]" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="lg:col-span-2 flex lg:justify-end">
                  <Link to="/contact" className="inline-flex items-center gap-2 border-b border-[#1A1D14]/40 pb-1 hover:border-[#B29774] hover:text-[#B29774] transition-colors">
                    Enquire <ArrowUpRight size={14} />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <CtaBanner />
    </main>
  );
}
